export const LIST_RELATORIO_ESTOQUE_ATUAL = 'LIST_RELATORIO_ESTOQUE_ATUAL'
export const LIST_RELATORIO_ESTOQUE_ATUAL_PENDING = 'LIST_RELATORIO_ESTOQUE_ATUAL_PENDING'
export const LIST_RELATORIO_ESTOQUE_ATUAL_SUCCESS = 'LIST_RELATORIO_ESTOQUE_ATUAL_SUCCESS'
export const LIST_RELATORIO_ESTOQUE_ATUAL_PDF_SUCCESS = 'LIST_RELATORIO_ESTOQUE_ATUAL_PDF_SUCCESS'
export const LIST_RELATORIO_ESTOQUE_ATUAL_FAILURE = 'LIST_RELATORIO_ESTOQUE_ATUAL_FAILURE'

export const LIST_RELATORIO_MOVIMENTACOES_PRODUTO = 'LIST_RELATORIO_MOVIMENTACOES_PRODUTO'
export const LIST_RELATORIO_MOVIMENTACOES_PRODUTO_PENDING = 'LIST_RELATORIO_MOVIMENTACOES_PRODUTO_PENDING'
export const LIST_RELATORIO_MOVIMENTACOES_PRODUTO_SUCCESS = 'LIST_RELATORIO_MOVIMENTACOES_PRODUTO_SUCCESS'
export const LIST_RELATORIO_MOVIMENTACOES_PRODUTO_FAILURE = 'LIST_RELATORIO_MOVIMENTACOES_PRODUTO_FAILURE'